import { List, Spin, Button, Tag } from 'antd'
import { DownloadOutlined, GiftOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'

import './styles.scss'
import { getAllCoursesByRole, getPaymentsByUserId, getUserById } from '../../../../../Constants/Api/functions/function'
import { generateInvoice } from '../../../../../Utils/InvoiceGenerator'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

const UserPayments = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [payments, setPayments] = useState([])
    const [cources, setCources] = useState([])
    const [selectedUser, setSelectedUser] = useState()
    const allCources = useSelector(state => state.allCources.allCources);
    const allUsers = useSelector((state) => state.allUsers.allUsers);
    const userId = useParams().id;

    useEffect(() => {
        if (allUsers.length) {
            const user = allUsers.find((user) => user.id === userId);
            setSelectedUser(user);
        } else {
            handleGetUserById(userId);
        }
    }, [allUsers])

    const handleGetUserById = async (userId) => {
        setIsLoading(true)
        try {
            const user = await getUserById(userId);
            setSelectedUser(user);
        } catch (error) {
            console.error('handleGetUserById', error);
        }
        setIsLoading(false)
    }

    useEffect(() => {
        if (allCources) {
            setCources(allCources)
        } else {
            handleGetCourses();
        }
    }, [allCources]);

    const handleGetCourses = async () => {
        try {
            const courses = await getAllCoursesByRole('superadmin');
            setCources(courses);
        } catch (error) {
            console.error('handleGetCourses', error);
        }
    }

    useEffect(() => {
        if (selectedUser) {
            handleGetPayments()
        }
    }, [selectedUser])

    const handleGetPayments = async () => {
        setIsLoading(true)
        try {
            let userPayments = await getPaymentsByUserId(selectedUser.id)
            setPayments(userPayments)
        } catch (error) {
            console.error('handleGetPayments', error)
        }
        setIsLoading(false)
    }

    return (
        <div className='user-payments'>
            <Spin
                spinning={isLoading}
                tip="Please wait..."
            >
                <div className='header'>
                    {selectedUser && <h1>
                        {`${selectedUser?.name}'s Payments`}
                    </h1>}
                </div>

                <div className='payments'>
                    <List
                        itemLayout="horizontal"
                        dataSource={payments}
                        renderItem={item => (
                            <List.Item
                                key={item.id}
                                className='payment-item'
                            >
                                <div className='payment'>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <h3>
                                            {cources.find((course) => course.id === item.courseId)?.name}
                                        </h3>
                                        <Button 
                                            type="link" 
                                            icon={<DownloadOutlined />}
                                            onClick={() => {
                                                const course = cources.find((c) => c.id === item.courseId);
                                                const isFullPayment = item.amount === course?.price || item.amount === course?.promoPrice || Boolean(item.couponCode);
                                                const planName = isFullPayment 
                                                    ? (item.amount === course?.promoPrice ? 'Promotional Full Payment' : (item.couponCode ? `Coupon Full Payment (${item.couponCode})` : 'Standard Full Payment')) 
                                                    : 'Installment Plan';
                                                
                                                const breakdown = (course?.installmentBreakdown && course.installmentBreakdown.length > 0)
                                                    ? course.installmentBreakdown
                                                    : (course?.alumniInstallmentBreakdown || []);
                                                
                                                generateInvoice({
                                                    paymentId: item.id,
                                                    amount: item.amount,
                                                    userName: selectedUser?.name,
                                                    courseName: course?.name,
                                                    coursePrice: course?.price,
                                                    coursePromoPrice: course?.promoPrice,
                                                    alumniDiscount: course?.alumniDiscount,
                                                    couponCode: item.couponCode,
                                                    discountAmount: item.discountAmount,
                                                    paymentMethod: item.paymentMethod,
                                                    paymentStatus: item.paymentStatus,
                                                    date: item.createdAt || item.paymentDate,
                                                    planName: planName,
                                                    installmentNumber: !isFullPayment && item.payedInstallments > 0 ? item.payedInstallments : undefined,
                                                    totalInstallments: course?.installments || breakdown?.length || 0,
                                                    installments: breakdown
                                                });
                                            }}
                                        >
                                            Download Invoice
                                        </Button>
                                    </div>
                                    <p>
                                        {`Payment ID: ${item.id}`}
                                    </p>
                                    <p>
                                        {`Amount: ${Number(item.amount).toLocaleString()} LKR`}
                                    </p>
                                    {item.couponCode && (
                                        <p style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '6px 0' }}>
                                            <span style={{ fontWeight: 600, color: '#03245e' }}>Coupon Applied:</span>
                                            <Tag color="cyan" style={{ fontWeight: 600 }}>
                                                <GiftOutlined style={{ marginRight: 4 }} />
                                                {item.couponCode} (-{Number(item.discountAmount || 0).toLocaleString()} LKR)
                                            </Tag>
                                        </p>
                                    )}
                                    <p>
                                        {`Date: ${item.createdAt}`}
                                    </p>
                                    <p>
                                        {`Method: ${item.paymentMethod}`}
                                    </p>
                                    {item.slipUrl && (
                                        <p>
                                            <a href={item.slipUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#1677ff', fontWeight: 'bold' }}>
                                                View Slip
                                            </a>
                                        </p>
                                    )}
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
            </Spin>
        </div>
    )
}

export default UserPayments